import React from "react";
import "./card.css";

export const Card = (props) => (
    <div className={"card" + (props.inverted ? " inverted" : "")} {...props}>
        {props.children}
    </div>
);
